export default {
  'serviceSettings.title': '服务流程',
  'serviceSettings.tabs.general': '基本设置',
  'serviceSettings.tabs.shopping-cart': '购物车',
  'serviceSettings.tabs.payment': '支付',
  'serviceSettings.tabs.delivery': '配送',
  'serviceSettings.tabs.pickup-served-notification': '取餐/出餐通知',

  'serviceSettings.section.floorPlan': '平面图',
  'serviceSettings.section.shoppingCart': '点餐页',
  'serviceSettings.section.send': '送厨',
  'serviceSettings.section.pay': '支付',
  'serviceSettings.section.clockInAndOut': '员工打卡',
  'serviceSettings.section.offlineMode': '离线模式',
  'serviceSettings.floorPlan': '平面图',
  'serviceSettings.floorPlan.helpText': '(全服务餐厅推荐使用)',
  'serviceSettings.floorPlan.description': '堂食订单会被指定到不同桌子',
  'serviceSettings.floorPlan.defaultViewingMode': '默认查看模式',
  'serviceSettings.floorPlan.turnOnClearningStatus': '开启清理中状态',
  'serviceSettings.floorPlan.turnOnClearningStatus.description':
    '用户需要在账单支付后确认桌子已准备就绪才能使用。确认前桌子将显示正在清理中。',
  'serviceSettings.floorPlan.startFlashingDurationThreshold': '当占桌时间达到指定时间时开始闪烁',
  'serviceSettings.floorPlan.turnOnCheckOverview': '开启分单概览',
  'serviceSettings.floorPlan.turnOnCheckOverview.description': '若开启，所有被占用的桌子将显示分单概览。',
  'serviceSettings.floorPlan.displayFullName': '显示名字全称(而非首字母)',
  'serviceSettings.floorPlan.enableSkipGuestsEnterShoppingCart': '点击空白桌位后直接进入购物车',
  'serviceSettings.floorPlan.enableSkipGuestsEnterShoppingCart.description':
    '开启后，在平面图中点击空桌时不会弹出 “选择客人数量” 窗口，直接进入购物车；默认客人数量为1。',
  'serviceSettings.floorPlan.enableTableCleaningAfterCheckout': '堂食订单关单后桌台进入待清台状态',
  'serviceSettings.floorPlan.enableTableCleaningAfterCheckout.description':
    '开启开关，堂食订单关单后，桌台状态将变为“待清台”（灰色）。需手动确认清台后，桌台才会恢复为空桌（绿色）。',
  'serviceSettings.floorPlan.enableTableCleaningAfterCheckout.tip': '（如需使用，请将POS APP升级至3.38.0版本）',
  'serviceSettings.quickPay': '送厨和支付',
  'serviceSettings.quickPay.helpText': '(快餐餐厅推荐使用)',
  'serviceSettings.quickPay.description': '送厨按钮和支付按钮会被合并成快速支付',
  'serviceSettings.promptForMemberIDEachTimeAfterOpeningATable': '每次开桌后弹窗引导会员信息输入',
  'serviceSettings.askCustomerInfoForCallInOrders': '对电话订餐订单询问客人信息',
  'serviceSettings.askCustomerInfoForCallInOrders.description': '如果此选项被开启，将会默认弹出询问客人信息的提示',
  'serviceSettings.backToHomeAfterSend': '送厨后返回上一页',
  'serviceSettings.backToHomeAfterSend.description': '如果此选项被开启，菜品送厨后将返回上一页',
  'serviceSettings.manuallyPrintingTheBillGoToThePreviousPage': '购物车手动打印账单后返回上一页',
  'serviceSettings.goToTheFloorPlanOrShoppingCartAfterEnteringThePIN': '输入PIN后进入点餐页',
  'serviceSettings.goToTheFloorPlanOrShoppingCartAfterEnteringThePIN.description':
    '如果此选项被开启，输入PIN后将进入平面图或点餐页',
  'serviceSettings.goToTheFloorPlanOrShoppingCartAfterEnteringThePIN.orderSourceTitle': '请选择默认订单来源',
  'serviceSettings.voidAuthorization': '废弃菜品是否需要授权',
  'serviceSettings.supportEmailAndTextReceipt': '询问客人收据选项',
  'serviceSettings.supportEmailAndTextReceipt.description':
    '如果此选项被开启，将会默认弹出询问客人收据选项，如电子邮件、短信和打印收据的提示',
  'serviceSettings.displaySendBatches': '显示送厨批次',
  'serviceSettings.consolidateIdenticalDishesAfterSend': '送厨后相同菜品合并显示',
  'serviceSettings.shoppingCartActionShortcuts': '购物车快捷按钮配置项(最多选择3个)',
  'serviceSettings.enterCentsFirst': '输入金额时先输入分位(从右到左)',
  'serviceSettings.delaySendToKitchen': '延迟送厨',
  'serviceSettings.delaySendToKitchen.terminal.title': '请选择一个POS终端 (必选)',
  'serviceSettings.delaySendToKitchen.terminal.description':
    '注意：延迟送厨必须通过一个POS终端来处理，此处理终端必须绑定厨房打印机。',
  'serviceSettings.enableGuestMode': '使用按座位点餐模式',
  'serviceSettings.displayDishImage': '显示菜品图片',
  'serviceSettings.enableCustomizationLimitProperties': '使用附加选项的限制属性',
  'serviceSettings.enableCustomizationLimitProperties.description':
    '开启后附加选项将检验并受限于最多选项数，最大可选数和每项最大可选数。',
  'serviceSettings.autoConfirmAndSend.paid': '已支付',
  'serviceSettings.autoConfirmAndSend.online.description': '(包含在线订餐和Branded App)',
  'serviceSettings.autoConfirmAndSend.unpaid': '未支付',
  'serviceSettings.autoConfirmAndSend.title': '自动确认订单并送厨',
  'serviceSettings.autoConfirmAndSend.kiosk.title': '自动确认已支付自助点餐机订单并送厨',
  'serviceSettings.autoConfirmAndSend.QRCode.title': '自动确认已支付扫码点餐订单并送厨',
  'serviceSettings.autoConfirmAndSend.terminal.title': '请选择一个POS终端 (必选)',
  'serviceSettings.autoConfirmAndSend.kiosk.autoFinish': '是否需要再手动通知自助点餐机订单？',
  'serviceSettings.autoConfirmAndSend.QRCode.autoFinish': '是否需要再手动通知扫码点餐订单？',

  'serviceSettings.autoConfirmAndSend.QRCode.autoToEmployee': '将自动确认的QR订单自动转移给员工:',
  'serviceSettings.autoConfirmAndSend.kiosk.autoToEmployee': '将自动确认的kiosk订单自动转移给员工:',
  'serviceSettings.autoConfirmAndSend.deliverectordering.chowbusOnlineOrderingAutoToEmployee':
    '将自动确认的chowbus online ordering订单自动转移给员工:',
  'serviceSettings.autoConfirmAndSend.deliverectordering.thirdPartyOnlineOrdersAutoToEmployee':
    '将自动确认的第三方线上平台订单自动转移给员工:',
  'serviceSettings.autoConfirmAndSend.autoToEmployee.description':
    '这样做可以将该订单的销售及小费计算为选中的这位员工。',
  'serviceSettings.autoConfirmAndSend.autoToEmployee.placeholder': '选择一个员工',

  'serviceSettings.autoConfirmAndSend.autoFinish': '是否需要再手动通知订单？',
  'serviceSettings.autoConfirmAndSend.autoFinish.description':
    'POS App v3.25.0及以上版本，支持取餐/出餐通知设置功能。请到服务流程设置中的取餐/出餐通知标签页进行设置。',
  'serviceSettings.autoConfirmAndSend.autoFinish.yes': '需要',
  'serviceSettings.autoConfirmAndSend.autoFinish.yes.description': '您可以在「待完成订单」下面进行通知顾客的操作',
  'serviceSettings.autoConfirmAndSend.autoFinish.no': '不需要',
  'serviceSettings.autoConfirmAndSend.terminal':
    '注意：自动确认订单必须通过一个POS终端来处理。我们建议您选择POS主机作为处理终端。',
  'serviceSettings.autoConfirmAndSend.terminal.serialNo': '序列号: ',
  'serviceSettings.showAggregatedCashFlow': '展示汇总的现金流',
  'serviceSettings.countChangeAsTips': '将找零作为小费',
  'serviceSettings.requireClockInAndOut': '要求员工上下班打卡',
  'serviceSettings.requireRecordBreaks': '要求员工记录休息时间',
  'serviceSettings.autoClockOutAtEndOfBusinessDay': '营业结束时自动为员工打卡下班',
  'serviceSettings.autoClockOutAtEndOfBusinessDay.description': '系统将按照报告截止时间自动为员工打卡下班。',
  'serviceSettings.automaticallyLabelDishes': '自动标注菜品',
  'serviceSettings.automaticallyLabelDishes.description': '所有菜品都将按添加到购物车时间先后顺序进行标记',
  'serviceSettings.automaticallyLabelDishes.printouts.title': '选择您希望显示标签的打印票据',
  'serviceSettings.whenToAutoPopUpCustomizationPanel.title': '请选择何时自动弹出附加选项选择页面？',
  'serviceSettings.whenToAutoPopUpCustomizationPanel.option.required':
    '只有当菜品有<span class="bold">必选</span>附加选项选择时',
  'serviceSettings.whenToAutoPopUpCustomizationPanel.option.exists': '当菜品有附加选项选择时',
  'serviceSettings.sortCustomizationsAsTheOrderDisplayed': '附加选项按购物车展示的顺序排序',
  'serviceSettings.sortCustomizationsAsTheOrderDisplayed.description': '关闭时，附加选项按照添加的顺序展示。',
  'serviceSettings.enableOpenTab': '允许开台',
  'serviceSettings.unableToToogleEnableOpenTabs': '在所有Open Tabs订单未关闭前不能关闭“允许开台”开关',
  'serviceSettings.enableTableService.prompt': '此开关关闭时，POS App将无法显示平面图。确认要继续吗？',

  'serviceSettings.autoConfirmAndSend.deliverectordering.autoFinish': '是否需要再手动通知线上平台订单？',

  'serviceSettings.autoConfirmAndSend.deliverectordering.autoFinish.finish_duration.02': '分钟后，自动完成订单',
  'serviceSettings.autoConfirmAndSend.deliverectordering.autoFinish.finish_duration':
    ' (此时间仅用于POS系统自动完成订单，不会影响第三方平台的备餐时间) ',
  'serviceSettings.offlineMode.reportsFirst':
    '如果网络恢复，结束离线模式后，将优先确保餐厅对账不出问题，而非确保不丢菜。',
  'serviceSettings.offlineMode.reportsFirst.tips':
    '开关关闭后，我们会最大限度地保留菜品信息，确保餐厅不丢菜。此开关无论开启还是关闭，都不会影响餐厅收款，仅应用于一些异常处理。推荐打开开关。',
  'serviceSettings.offlineMode.reportsFirst.note':
    '说明：餐厅断网时设备会在30秒后自动进入离线模式。离线模式下，您可以正常使用POS（点菜、送厨、打印、支付）。',
  'serviceSettings.offlineMode.reportsFirst.caution':
    '注意：建议您全店使用一个设备进行操作，避免多设备同时操作一个订单出现付款或账目异常。',
  'serviceSettings.actionsEnabledAuthorizationKeypad': '当用户没有权限时，启用授权键盘进行以下操作',
  'serviceSettings.enablePartialPaymentByCreditCard': '允许刷卡支付部分金额',
  'serviceSettings.enablePartialPaymentByCreditCard.recommend': '推荐分单较多的堂食店使用',
  'serviceSettings.enablePartialPaymentByCreditCard.description': '刷卡支付时可支持部分支付，不必按金额分单。',

  'serviceSettings.quickInputForPhoneNumber': '电话号码快捷输入（3位）',
  'serviceSettings.disappearingCallLogMode': '来电记录消失模式（使用caller id时）',
  'serviceSettings.autoDelete': '自动删除（点击查看后）',
  'serviceSettings.swipeLeftToDeleteManually': '左滑手动删除',
  'serviceSettings.delivery.callInOrders': '电话订单',
  'serviceSettings.delivery.DriverName': '司机',
  'serviceSettings.delivery.useYourOwnDeliveryDrivers': '使用自己的司机配送',
  'serviceSettings.delivery.maximumDeliveryRadius': '最大配送距离（半径）',
  'serviceSettings.delivery.maximumDeliveryRadiusUnit': '英里',
  'serviceSettings.delivery.driveryFree': '配送费',
  'serviceSettings.delivery.configureDeliveryServiceFees': '设置配送费',
  'serviceSettings.delivery.customDeliveryFeeTaxable': '自定义配送费：是否收税？',
  'serviceSettings.delivery.customDeliveryFeeTaxable.yes': '是',
  'serviceSettings.delivery.customDeliveryFeeTaxable.no': '否',

  'serviceSettings.section.toolsBar.title': '工具栏',
  'serviceSettings.section.toolsBar.column.icon': '图标',
  'serviceSettings.section.toolsBar.column.function': '功能',
  'serviceSettings.section.toolsBar.column.visible': '是否可见',

  'serviceSettings.section.pickup-served-notification.tips': 'POS App v3.25.0及以上版本，支持取餐/出餐通知设置功能。',
  'serviceSettings.section.pickupNotificationSettings': '顾客取餐通知设置',
  'serviceSettings.section.thirdPartyPlatformNotificationSettings': '第三方平台通知设置',
  'serviceSettings.section.thirdPartyPlatformNotificationSettings.tips':
    '按第三方平台规则，Chowbus系统将自动同步，并由第三方平台按其规则通知',
  'serviceSettings.section.notificationMethod': '通知方式',
  'serviceSettings.section.notificationMethod.sms': '短信通知',
  'serviceSettings.section.notificationMethod.sms.description': '登录会员或留存手机号的顾客，发送取餐通知短信。',
  'serviceSettings.section.cps': '取餐叫号屏',
  'serviceSettings.section.cps.description': '已出餐和制作中的订单，小票号显示在取餐叫号屏上。',
  'serviceSettings.section.cps.link': '设置取餐叫号屏',
  'serviceSettings.section.notificationScope': '通知范围',
  'serviceSettings.section.notificationScope.orderSource': '订单来源',
  'serviceSettings.section.notificationScope.orderSource.walkIn': '到店点餐',
  'serviceSettings.section.notificationScope.orderSource.callIn': '电话订餐',
  'serviceSettings.section.notificationScope.orderSource.qrCode': '扫码点餐',
  'serviceSettings.section.notificationScope.orderSource.kiosk': '自助点餐机',
  'serviceSettings.section.notificationScope.orderSource.online': '线上订餐',
  'serviceSettings.section.notificationScope.orderSource.website': '（Website & Branded App）',
  'serviceSettings.section.notificationScope.orderSource.thirdPartyPlatform': '（第三方平台）',
  'serviceSettings.section.notificationScope.serviceType': '服务方式',
  'serviceSettings.section.notificationScope.serviceType.dineIn': '堂食',
  'serviceSettings.section.notificationScope.serviceType.takeOut': '外带',
  'serviceSettings.section.notificationScope.serviceType.delivery': '递送',
  'serviceSettings.section.notificationScope.sendingNotificationMethod': '发送通知方式',
  'serviceSettings.section.notificationScope.sendingNotificationMethod.manualNotification': '手动发送通知',
  'serviceSettings.section.notificationScope.sendingNotificationMethod.manualNotification.tips':
    '手动发送通知：在 POS App 未完成订单界面中，手动点击Ready按钮。',
  'serviceSettings.section.notificationScope.sendingNotificationMethod.automaticNotification': '自动发送通知',
  'serviceSettings.section.notificationScope.sendingNotificationMethod.automaticNotification.suffix':
    '分钟后，自动通知取餐',
};
